/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Data_Storage_DescInputs */

const en_ui_data_storage_desc = /** @type {(inputs: Ui_Data_Storage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where your sessions come from and what they take up — all stored locally in your browser`)
};

const de_ui_data_storage_desc = /** @type {(inputs: Ui_Data_Storage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woher deine Einheiten kommen und wie viel Platz sie brauchen – alles lokal in deinem Browser`)
};

/**
* | output |
* | --- |
* | "Where your sessions come from and what they take up — all stored locally in your browser" |
*
* @param {Ui_Data_Storage_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_data_storage_desc = /** @type {((inputs?: Ui_Data_Storage_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Data_Storage_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_data_storage_desc(inputs)
	return de_ui_data_storage_desc(inputs)
});